/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import ModalWrapper from '../../../../Common/ModalWrapper/ModalWrapper';
import ModalContent from '../../../../Common/ModalWrapper/Partials/ModalContent';

import { ducks as checkoutDucks } from '../../../../../../../../state/ducks/Checkout';

import BrandLogo from '../Partials/BrandLogo';
import SecureCheckout from '../Partials/SecureCheckout';
import Breadcrumb from '../Partials/Breadcrumb/Breadcrumb';
import CheckoutMobileHeader from './CheckoutMobileHeaders';
import DesktopMobile from '../../../../../../../helpers/DesktopMobile/DesktopMobile';
import { getDataDictionary } from '../../../../../../../../state/ducks/App/App-Selectors';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getPresentationFamily } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import CheckoutHeaderPLA from '../../../../../../../components/GraphqlComponents/GraphqlHeader/CheckoutHeaderPLA';
import CheckoutMetaHeaderPLA from '../../../../../../../components/GraphqlComponents/GraphqlHeader/CheckoutMetaHeaderPLA';

// These are backup in case the logo has not been added in ContentStack.
const logos = {
    PLA: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt55247e0014fdfe9f/5f3ec458eb93e224977c1ab8/plants.png',
    CAN: 'https://images.contentstack.io/v3/assets/blt1253a5c1b168c76d/blt21d302c72abb41cd/5fa147c11a81c1644e99894c/canada-logo.png',
    '08F': 'https://images.contentstack.io/v3/assets/bltff8fca2c07fbcc09/blt7cadaed6919db76f/5f71a681968bb93b9e851898/0800flowers_logo_purple.png',
    '18F': 'https://cdn2.1800flowers.com/wcsstore/Flowers/images/2018/mobile/flowers-stacked-logo.png',
    '18B': 'https://cdn2.1800baskets.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/18b-logo-v2.svg',
    CCO: 'https://cdn2.cheryls.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/cco-logo-v2.svg',
    HD: 'https://cdn2.harryanddavid.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/hd-logo-v2.svg',
    FBQ: 'https://images.contentstack.io/v3/assets/blte4aebfe2fb7fcc9d/blta7725399a4bc9f66/5f0484eabece672e221df519/FruitBouquets.png',
    BRY: 'https://images.contentstack.io/v3/assets/blt22a4279bb3e9cfce/blt3da066ed42ac5829/5f11e308c31823015df6ee2a/SharisLogo_r.svg',
};

const {
    common: { commonSelectors },
} = checkoutDucks;

const styles = (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '1400px',
        marginTop: '13px',
        padding: '0 0 10px',
        backgroundColor: theme.palette.headerColor,
        marginBotton: '30px',
        justifyContent: 'space-between',
        margin: '0 auto 5px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '0',
        },
    },
    brandLogo: {
        justifyContent: 'flex-start',
        [theme.breakpoints.down('md')]: {
            margin: ' 0 auto',
            width: '50%',
            maxWidth: '250px',
        },
        '&.PLA': {
            margin: '0',
            width: '100%',
            maxWidth: 'unset',
            '& button': {
                display: 'inline-block',
                '& ~div': {
                    float: 'right',
                    display: 'inline-flex',
                },
            },
        },
    },
    navProgress: {
        display: 'flex',
        justifyContent: 'center',
        height: 'auto',
        margin: '0',
        '& h4': {
            textAlign: 'center',
        },
        /* commenting out for now, breadcurm is getting hidden for resolution below 820px
        '@media (max-width: 820px)': {
            display: 'none',
        },
        */
    },
    secureCheckout: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            width: '25%',
        },
    },
    plaHeaderOptions: {
        display: 'flex',
    },
    logoBrandBtn: {
        backgroundColor: 'transparent',
        fontSize: '14px',
        fontWeight: 'bold',
        margin: '0',
        display: 'block',
        '&:hover, &:focus, &:active': {
            backgroundColor: 'transparent',
        },
        [theme.breakpoints.down('md')]: {
            padding: '0',
            '& span': {
                display: 'flex',
            },
        },
    },
    mobileHeaderBlock: {
        color: theme.palette.white,
        display: 'flex',
        padding: '10px',
        background: theme.palette.white,
        borderBottom: `2px solid ${theme.palette.cms?.checkoutHeaderBg || theme.palette.checkoutHeaderBg}`,
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    plantsCheckoutHeader: {
        marginBottom: '0px !important',
        paddingBottom: '0px !important',
    },
});

class CheckoutHeader extends Component {
    constructor(props) {
        super(props);
        const {
            orderId, deliveryFormFields, placeOrderStatus,
        } = this.props;
        this.state = {
            isOpen: false,
            tabs: [
                {
                    label: 'Delivery',
                    filledStatus: false,
                    disabled: false,
                    linkUrl: `/checkout/shipping/${orderId}`,
                },
                {
                    label: 'Payment',
                    filledStatus: deliveryFormFields.isFormValid,
                    disabled: true,
                    linkUrl: `/checkout/payment/${orderId}`,
                },
                {
                    label: 'Review',
                    filledStatus: placeOrderStatus,
                    disabled: true,
                    linkUrl: `/checkout/review-order/${orderId}`,
                },
            ],
            activeTab: 0,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const { currentTab } = this.props;
        const { activeTab } = this.state;
        if (activeTab !== currentTab) {
            this.setActiveTab(currentTab);
        }
    }

    setActiveTab(activeTab) {
        const { deliveryFormFields, placeOrderStatus } = this.props;
        const { tabs } = this.state;
        const updateTabs = [];

        tabs.forEach((element, index) => {
            updateTabs[index] = element;

            if (updateTabs[index].label === 'Delivery') {
                updateTabs[index].filledStatus = deliveryFormFields.isFormValid;
                updateTabs[index].disabled = !deliveryFormFields.isFormValid;
            }
            if (updateTabs[index].label === 'Payment') {
                updateTabs[index].filledStatus = placeOrderStatus;
                updateTabs[index].disabled = !placeOrderStatus;
            }
            if (updateTabs[index].label === 'Review') {
                updateTabs[index].filledStatus = placeOrderStatus;
                updateTabs[index].disabled = !placeOrderStatus;
            }
        });
        this.setState({ tabs: updateTabs, activeTab });
    }

    openModal() {
        this.setState({ isOpen: true });
    }

    closeModal() {
        this.setState({ isOpen: false });
    }

    isAddOnWrapUp() {
        const { location: { pathname } } = this.props;
        if (pathname === '/wrap-up' || pathname === '/add-ons') {
            return true;
        }
        return false;
    }

    render() {
        const {
            classes, currentTab, placeOrderStatus, brand, dataDictionary,
        } = this.props;
        const { isOpen } = this.state;
        const modalContent = <ModalContent closeModal={this.closeModal} dataDictionary={dataDictionary} />;

        return (
            <DesktopMobile
                mobile={() => (
                    <CheckoutMobileHeader
                        modalContent={modalContent}
                        isOpen={isOpen}
                        onCloseModal={this.closeModal}
                        btnClose={false}
                        classes={classes}
                        isAddOnWrapUp={this.isAddOnWrapUp()}
                        onClick={this.openModal}
                        currentTab={currentTab}
                        isPlaceOrder={placeOrderStatus}
                        withLink
                        brand={brand}
                        dataDictionary={dataDictionary}
                        pathname={this.props.location.pathname}
                    />
                )}
                desktop={() => (
                    <Grid
                        container
                        className={`${classes.root} checkout-header-container ${brand.code === 'PLA' && classes.plantsCheckoutHeader}`}
                    >
                        <Grid item xs={3} className={classes.brandLogo}>
                            <Button
                                id="btn-logo-brand"
                                data-test="btn-logo-brand"
                                data-testid="btn-logo-brand"
                                name="logoBrandButton"
                                className={classes.logoBrandBtn}
                                aria-label="18F"
                                onClick={this.openModal}
                            >
                                <BrandLogo withLink brand={brand.code} brandLogos={logos} />
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.navProgress}>
                            {this.isAddOnWrapUp()
                                ? (
                                    <h4>Make Your Gift Extra Special</h4>
                                ) : (
                                    <>
                                        {
                                            currentTab
                                                ? <Breadcrumb active={currentTab} isPlaceOrder={placeOrderStatus} /> : null
                                        }
                                    </>
                                )}
                        </Grid>
                        <Grid item xs={3} className={`${classes.secureCheckout} ${brand.code === 'PLA' ? classes.plaHeaderOptions : ''}`}>
                            {
                                brand.code === 'PLA'
                                    ? <CheckoutHeaderPLA brand={brand} />
                                    : <SecureCheckout dataDictionary={dataDictionary} />
                            }
                        </Grid>
                        {
                            brand.code === 'PLA' && this.props.location.pathname.indexOf('/cart/') === -1 ? <CheckoutMetaHeaderPLA /> : ''
                        }
                        <ModalWrapper
                            modalTitle={dataDictionary?.['LEAVE CHECKOUT'] || 'LEAVE CHECKOUT'}
                            modalContent={modalContent}
                            isOpen={isOpen}
                            onCloseModal={this.closeModal}
                            btnClose={false}
                        />
                    </Grid>
                )}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    orderId: commonSelectors.getOrderId(state),
    deliveryFormFields: commonSelectors.getRecipientForm(state),
    placeOrderStatus: commonSelectors.getPlaceOrderStatus(state),
    continueToPayment: commonSelectors.continueToPayment(state),
    brand: getBrand(state),
    presentation_family: getPresentationFamily(state),
    dataDictionary: getDataDictionary(state),
});

CheckoutHeader.propTypes = {
    placeOrderStatus: PropTypes.bool.isRequired,
    deliveryFormFields: PropTypes.object.isRequired,
    orderId: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    currentTab: PropTypes.string,
    location: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
    dataDictionary: PropTypes.object,
};

CheckoutHeader.defaultProps = {
    currentTab: null,
    dataDictionary: {},
};

export default compose(
    connect(mapStateToProps, null),
    withStyles(styles),
    withRouter,
)(CheckoutHeader);
